import { type FC, useEffect, useRef, useState } from "react";
import { Image as ChakraImage, type ImageProps as ChakraImageProps } from "~/foundation/Chakra";

export type LazyImageProps = ChakraImageProps & {
	setClassName?: boolean;
};

export const LazyImage: FC<LazyImageProps> = (props) => {
	const imageRef = useRef<HTMLImageElement>(null);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		if (!loaded && imageRef.current?.complete) {
			setLoaded(true);
			imageRef.current.classList.add("image-loaded");
			imageRef.current.parentElement?.classList.add("is-visible");
		}
	}, []);

	return (
		<ChakraImage ref={imageRef} {...props} loading="lazy" onLoad={(e) => {
			const element = (e.target as HTMLImageElement);
			element.classList.add("image-loaded");
			element.parentElement?.classList.add("is-visible");
			setLoaded(true);
			props.onLoad?.(e)
		}} />
	)
};